import React, { Component, useState } from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import CartContext from "./CartContext";
import { Audio, Watch, ThreeDots } from "react-loader-spinner";

export class LoadSpinner extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      open: this.props.open,
      callback: this.props.callback,
    };
  }
  customstyle = {
    content: {
      ...Modal,
    },
    overlay: { zIndex: 3000 },
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.callback();
  };
  render() {
    return (
      <>
        <Modal
          size="sm"
          width="20pt"
          className="spinnermodal-backdrop spinnermodalcenter "
          show={this.state.open}
          keyboard={false}
          style={{ opacity: "50 !important" }}
        >
          <Modal.Body
            className="loadspinnermodalalign "
            style={{
              backgroundColor: "bg-white",
              color: "green",
            }}
          >
            <div>
              <ThreeDots
                height="80"
                width="80"
                radius="9"
                color="green"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              />
              {/* <Bars
                height="80"
                width="350"
                color="#4fa94d"
                ariaLabel="bars-loading"
                wrapperStyle={{}}
                wrapperClass=""
                visible={true}
              /> */}
              {/* <Watch
                height="80"
                width="350"
                radius="48"
                color="#4fa94d"
                ariaLabel="watch-loading"
                wrapperStyle={{}}
                wrapperClassName=""
                visible={true}
              /> */}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
